import axios from "axios"

export default {
    SurveillanceReason:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/healthreport/surveillancereason/update' : '/api/healthreport/surveillancereason/create',data)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/healthreport/surveillancereason/table',data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/healthreport/surveillancereason/delete/${id}`)
            return response
        },
        async List(){
            const response = await axios.post('/api/healthreport/surveillancereason/list')
            return response
        }
    },
    Employee:{
        async Create(data){
            const response = await axios.post('/api/healthreport/create',data)
            return response
        },
        async Update(data){
            const response = await axios.post('/api/healthreport/update',data)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/healthreport/table',data)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/healthreport/delete/${id}`)
            return response
        },
    },
    async Report(data){
        const response = await axios.post('/api/healthreport/report',data)
        return response
    },
    async Dashboard(){
        const response = await axios.get('/api/healthreport/dashboard')
        return response
    },
}